const addServicesActions = {
  ADD_SERVICES_INIT: 'ADD_SERVICES_INIT',
  ADD_SERVICES_SET: 'ADD_SERVICES_SET'
};
export default addServicesActions;
